var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data",style:({ 'font-size': _vm.fontSize, color: _vm.color })},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }